var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckForm = function SvgCheckForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), "Add commentMore actions", _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.98 7.016s.5.5 1 1.5c0 0 1.589-2.5 3-3M9.995 2.021c-2.499-.105-4.429.182-4.429.182-1.219.088-3.555.77-3.555 4.762 0 3.956-.025 8.834 0 10.779 0 1.188.736 3.96 3.282 4.108 3.095.18 8.67.219 11.227 0 .685-.039 2.965-.576 3.253-3.056.299-2.57.24-4.355.24-4.78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M22 7.016c0 2.761-2.24 5-5.005 5a5 5 0 0 1-5.005-5c0-2.762 2.24-5 5.005-5a5 5 0 0 1 5.005 5ZM6.98 13.016h4M6.98 17.016h8"
  })));
};
export default SvgCheckForm;